export default __webpack_public_path__ + "images/A2.a296212.png";